import { TileOrLanguageActions } from "components/dynamic-content/util/dynamicContent"
import Tile, { DisabledTile } from "components/views/atoms/Tile"
import { ITile } from "contentful-types"
import React, { ReactElement } from "react"
import { fieldIsValid, getIconUrl, getTileOnClick, isTileDeadEnd } from "../utils/mappingUtils"
import { Condition } from "components/dynamic-content/CondiitonalGate"
import { toCondition } from "../utils/conditionUtils"

type TileElementProps = {
  tile: ITile
  actions: TileOrLanguageActions
  baseUrl: string
  doesUserSatisfyConditions: (conditions: Array<Condition>) => boolean
}

const TileElement = ({
  tile,
  actions,
  baseUrl,
  doesUserSatisfyConditions
}: TileElementProps): ReactElement<typeof Tile> => {
  const {
    fields: { display, conditions }
  } = tile

  if (!fieldIsValid(display)) {
    return null
  }

  const {
    fields: { title, description, icon, secondaryDescription }
  } = display

  if (isTileDeadEnd(tile, doesUserSatisfyConditions)) {
    return (
      <DisabledTile
        title={title}
        description={"Chats are not available in your chosen location."}
        iconUrl={getIconUrl(icon)}
      />
    )
  }

  return (
    <>
      {!conditions || doesUserSatisfyConditions(conditions.map(toCondition)) ? (
        <Tile
          title={title}
          description={description}
          secondaryDescription={secondaryDescription}
          iconUrl={getIconUrl(icon)}
          onClick={getTileOnClick({ tile, actions, baseUrl })}
        />
      ) : null}
    </>
  )
}

export { TileElement }
